module.exports = __webpack_public_path__ + "static/media/space_where_guest_can_cook_thier_own_meal.381b0322.svg";